import React from 'react';
import { FaTimes, FaChalkboardTeacher, FaAward, FaLaptopCode, FaLinkedin,FaUserGraduate } from 'react-icons/fa';
import './css/TrainerDetailsPopup.css'; 
import akashImaage from '../img/akash1.jpg';
const TrainerDetailsPopup = ({ onClose }) => {
  return (
    <div className="trainer-popup-overlay">
      <div className="trainer-popup-container">
        <button className="trainer-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
        
        <div className="trainer-header">
          <img 
            src={akashImaage} 
            alt="Trainer" 
            className="trainer-image"
          />
          <h3>Er.Akash G C</h3>
          <p className="trainer-title">Senior Software Engineer and Instructor</p>
        </div>
        

        <div className="trainer-details">
  <div className="trainer-section">
    <h4><FaChalkboardTeacher /> About Me</h4>
    <p>
      I’m a passionate .NET developer with strong expertise in backend and frontend
      technologies, specializing in C#, .NET Core 7/8, Blazor, and React. Over the years,
      I’ve worked on diverse projects including booking systems, delivery platforms,
      fitness apps, and restaurant management tools. My goal is to create efficient,
      scalable, and user-friendly solutions while mentoring others in the tech field.
    </p>
  </div>
  
  <div className="trainer-section">
    <h4><FaAward /> Qualifications</h4>
    <ul className="trainer-qualifications">
      <li>M.Sc. in Computer Science & Engineering – NCIT (With Full Scholarship)</li>
      <li>Bachelor in Computer Engineering – LEC (With Full Scholarship)</li>
      <li>Specialized in Backend Development (C#, .NET Core, ASP.NET MVC)</li>
      <li>Proficient in Frontend (Blazor, React, HTML, CSS, JavaScript)</li>
      <li>Experienced in Database (MS SQL), REST API, and SOAP</li>
    </ul>
  </div>
  
  <div className="trainer-section">
    <h4><FaUserGraduate /> Instructor & Training Experience</h4>
    <ul className="trainer-qualifications">
      <li>Instructor at TechShara – Conducted .NET, C Programming, and Web Development workshops.</li>
      <li>Trainer at H Sipayla – Led practical training sessions on modern web technologies.</li>
      <li>Personal 1-on-1 Training – Mentored individuals in programming and project development.</li>
      <li>Group Training – Conducted sessions for more than 10 batches and over 30 students.</li>
      <li>Lecturer roles at Kathmandu Institute of Technology & Khowpa Engineering College.</li>
    </ul>
  </div>

  <div className="trainer-section">
    <h4><FaLaptopCode /> Experience</h4>
    <div className="trainer-experience">
      <div className="experience-item">
        <h5>DotNet Developer – CodeBee Pvt. Ltd.</h5>
        <p>Mar 2023 – Present</p>
        <p>Worked on WallBee Booking & Delivery System, WOWFIT fitness platform, and support systems, leading module development and team coordination.</p>
      </div>
      <div className="experience-item">
        <h5>DotNet Developer – TechBit Nepal</h5>
        <p>May 2022 – Feb 2023</p>
        <p>Built food delivery platform and restaurant management tools with secure payments and order tracking.</p>
      </div>
      <div className="experience-item">
        <h5>DotNet Developer (Intern) – M & R Solution</h5>
        <p>Jan 2020 – Mar 2020</p>
        <p>Developed accounting software with financial management and automation features.</p>
      </div>
      <div className="experience-item">
        <h5>Department Coordinator – Kathmandu Institute of Technology</h5>
        <p>Apr 2020 – May 2022</p>
        <p>Managed departmental operations, coordinated academic activities, and contributed to curriculum planning and academic quality improvements.</p>
      </div>
      <div className="experience-item">
        <h5>Part-Time Lecturer – Kathmandu Institute of Technology</h5>
        <p>May 2022 – Jan 2024</p>
        <p>Taught C Programming, C++, .NET Technologies, Software Engineering, DSA, and Web Technologies to undergraduate students.</p>
      </div>
      <div className="experience-item">
        <h5>Part-Time Lecturer – Khowpa Engineering College</h5>
        <p>Nov 2020 – Jan 2022</p>
        <p>Taught core computer engineering subjects to undergraduate students.</p>
      </div>
    </div>
  </div>
  
  <div className="trainer-social">
    <a href="https://www.linkedin.com/in/akashgc/" target="_blank" rel="noopener noreferrer">
      <FaLinkedin /> Connect on LinkedIn
    </a>
  </div>
</div>



      </div>
    </div>
  );
};

export default TrainerDetailsPopup;